"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -131,
        'y': -834.5,
        'width': 528,
        'height': 180
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -131,
        'y': -639.5,
        'width': 528,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1142,
        'y': -789.5,
        'width': 528,
        'height': 108
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 54,
      'letterSpacing': 0,
      'lineHeightPx': 54,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1142,
        'y': -666.5,
        'width': 528,
        'height': 54
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2046,
        'y': -805,
        'width': 327,
        'height': 189
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 54,
      'letterSpacing': 0,
      'lineHeightPx': 54,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2046,
        'y': -601,
        'width': 327,
        'height': 54
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[desktop]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 18,
      'letterSpacing': 0,
      'lineHeightPx': 27,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -131,
        'y': 325.5,
        'width': 528,
        'height': 108
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 54,
      'letterSpacing': 0,
      'lineHeightPx': 54,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -131,
        'y': 448.5,
        'width': 528,
        'height': 54
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[tablet]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1142,
        'y': 346.5,
        'width': 528,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 36,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1142,
        'y': 445.5,
        'width': 528,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[mobile]': {
    'line1': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2046,
        'y': 336,
        'width': 327,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 36,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 2046,
        'y': 456,
        'width': 327,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;